import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import {
  AngularMyDatePickerDirective,
  IAngularMyDpOptions,
  IMyDateModel,
} from 'angular-mydatepicker';
import * as moment from 'moment';
import { Config } from '@shared/config';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'app-ph-datepicker',
  templateUrl: './ph-datepicker.component.html',
  styleUrls: ['./ph-datepicker.component.scss'],
})
export class PhDatepickerComponent implements OnInit {
  @Output() phDatepickerChange: EventEmitter<any> = new EventEmitter();
  @Input() initValue: string = null;
  @Input() correctForm: UntypedFormControl;
  @Input() labelId: number;
  @Input() formControl: UntypedFormControl;
  @Input() datepickerReadOnly: boolean = false;
  @Input() disableDatepickerIcon: boolean = false;
  @Input() extraOptions: object;
  @Input() onChanged: any;
  datepickerOptions: IAngularMyDpOptions = {
    dateRange: false,
    dateFormat: Config.DATE_FORMAT_FRONTEND_SHORT.toLowerCase(),
    inputFieldValidation: false,
    disableSince: this.dayNow,
    openSelectorTopOfInput: true,
    disableUntil: {
      year: 1900,
      month: 1,
      day: 1,
    },
  };
  model: IMyDateModel = null;
  @ViewChild('mydatepicker') mydp: AngularMyDatePickerDirective;

  constructor() {}

  ngOnInit() {
    if (this.extraOptions) {
      this.datepickerOptions = {
        ...this.datepickerOptions,
        ...this.extraOptions,
      };
    }
    // if form changed -> change date
    this.correctForm.valueChanges.subscribe((el) => {
      // if (typeof el !== 'string') {
      //   return;
      // }
      this.setDate(el);
    });
    if (this.initValue) {
      this.setDate(this.initValue);
    }
  }

  toggleCalendar(event) {
    if (!this.datepickerReadOnly) {
      event.preventDefault();
      event.stopPropagation();
      this.mydp.toggleCalendar();
    }
  }

  setDate(date) {
    if (date !== null) {
      this.model = {
        isRange: false,
        singleDate: { jsDate: moment(date, Config.DATE_FORMAT_BACKEND).toDate() },
      };
    } else {
      // this.mydp.clearDate();
      this.model = null;
    }
  }

  change(event) {
    const correctDate = moment(event.singleDate.jsDate).format(Config.DATE_FORMAT_BACKEND);
    this.phDatepickerChange.emit(correctDate);
  }

  get dayNow() {
    const nowDay = moment().add(1, 'days');
    return {
      year: parseInt(nowDay.format('YYYY'), 10),
      month: parseInt(nowDay.format('M'), 10),
      day: parseInt(nowDay.format('D'), 10),
    };
  }
}
